var exports = {
  "I6": "inputWrapper__jNYz-A",
  "mK": "imageAttachments___zvm-8",
  "jY": "isDraggedOver__mpXRNs",
  "cd": "autocompleteWrapper__7gQdo-",
  "uZ": "composerMinHeight__y_ZVW4",
  "Nx": "composerNewConversationMinHeight__0z0Dk2",
};

module.exports = exports;
